/** @typedef {'light' | 'dark' | 'system'} ThemePreference */

export const THEME_STORAGE_KEY = "mkc_theme_preference";

const ALLOWED = ["light", "dark", "system"];

/**
 * @param {unknown} value
 * @returns {ThemePreference}
 */
export function normalizeThemePreference(value) {
  if (typeof value === "string" && ALLOWED.includes(value)) return value;
  return "system";
}

/**
 * Resolved theme for CSS [data-mkc-theme].
 * @param {ThemePreference} pref
 * @returns {'light' | 'dark'}
 */
export function resolveTheme(pref) {
  if (pref === "dark") return "dark";
  if (pref === "light") return "light";
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "light";
}

/**
 * @param {ThemePreference} pref
 */
export function applyThemePreference(pref) {
  const normalized = normalizeThemePreference(pref);
  const resolved = resolveTheme(normalized);
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-mkc-theme", resolved);
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, normalized);
  } catch {
    /* ignore */
  }
}

/** Run before React (see public/index.html) to reduce flash */
export function applyThemeFromStorage() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    applyThemePreference(normalizeThemePreference(raw));
  } catch {
    applyThemePreference("system");
  }
}
